<style lang="scss" scoped></style>

<template>
    <div>
        <compWrapper
            :title="
                $t('global.common.base_information', {
                    defaultValue: '基本信息',
                })
            "
            theme="primary"
        >
            <compFormEdit
                ref="formbase"
                align="center"
                class="margin-top-15"
                :formdata="getBase"
                v-model="formData"
            ></compFormEdit>
            <footer
                class="width-50per"
                style="padding-left: 120px; margin-left: 25%"
            >
                <vButton
                    theme="primary"
                    class="margin-right-15"
                    @click="handleDownload"
                    >{{
                        $t("fbb.producticon.print", {
                            defaultValue: "开始打印",
                        })
                    }}</vButton
                >
                <vButton theme="error" class="margin-right-15" @click="reset">{{
                    $t("global.common.reset", { defaultValue: "重置" })
                }}</vButton>
            </footer>
        </compWrapper>
        <Spin size="large" fix v-if="loading"></Spin>
    </div>
</template>

<script>
import { mapGetters } from "vuex";
import { HttpGetSku } from "@/service/products/allproducts";
export default {
    props: ["baseInfo"],
    components: {
        compWrapper: () => import("@components/templates/wrapper"),
        compFormEdit: () => import("@components/templates/formedit"),
    },
    data() {
        return {
            loading: false,
            formData: {
                sku: this.baseInfo.erpSku,
                alias: this.baseInfo.erpSkuCode,
                description: this.baseInfo.nameEn,
                pageSize: 1,
                country: "China",
                productState: "NEW",
            },
        };
    },
    created() {
        console.log(this.baseInfo);
    },
    computed: {
        getBase() {
            return [
                {
                    label: this.$t("fbb.producticon.parper", {
                        defaultValue: "纸张类型",
                    }),
                    tag: "vSelect",
                    key: "pageSize",
                    options: [{ label: "Letter Size", value: 1 }],
                    props: {
                        filterable: true,
                    },
                },
                {
                    label: this.$t("fbb.production.compose_type", {
                        defaultValue: "排版方式",
                    }),
                    tag: "vSelect",
                    key: "type",
                    options: [
                        {
                            label: this.$t(
                                "fbb.production.compose_type_options_1",
                                { defaultValue: "一页多个" }
                            ),
                            value: 1,
                        },
                        {
                            label: this.$t(
                                "fbb.production.compose_type_options_2",
                                { defaultValue: "一页一个" }
                            ),
                            value: 2,
                        },
                    ],
                },
                {
                    label: this.$t("fbb.producticon.icon", {
                        defaultValue: "标签码",
                    }),
                    tag: "vInput",
                    key: "alias",
                    // on: {
                    //     "on-blur": this.getSkuInfo,
                    // },
                    formItem: {
                        tip:
                            "<div class=color-error>" +
                            this.$t("fbb.producticon.iconItem", {
                                defaultValue: "生成条码的产品标签",
                            }) +
                            "</div>",
                    },
                },
                {
                    label: "ERP SKU",
                    tag: "vInput",
                    key: "sku",
                },
                {
                    label: this.$t("fbb.producticon.prodesc", {
                        defaultValue: "产品描述",
                    }),
                    tag: "vInput",
                    key: "description",
                    formItem: {
                        tip:
                            "<div class=color-error>" +
                            this.$t("fbb.producticon.prodescItem", {
                                defaultValue:
                                    "默认为系统维护的产品描述，可以根据实际情况修改",
                            }) +
                            "</div>",
                    },
                },
                {
                    label: this.$t("fbb.producticon.shopstatus", {
                        defaultValue: "商品状况",
                    }),
                    tag: "vInput",
                    key: "productState",
                },
                {
                    label: this.$t("fbb.producticon.procountry", {
                        defaultValue: "生产国",
                    }),
                    tag: "vSelect",
                    key: "country",
                    options: [
                        {
                            value: "China",
                            label: "China",
                        },
                        {
                            value: "USA",
                            label: "USA",
                        },
                    ],
                },
                {
                    label: this.$t("fbb.producticon.othernews", {
                        defaultValue: "其他识别信息",
                    }),
                    tag: "vInput",
                    key: "meta",
                    required: false,
                },
            ];
        },
    },
    methods: {
        reset() {
            this.formData = {};
            this.calcList = [];
            this.$refs.formbase.resetValidate();
        },
        async handleDownload() {
            const valid = await this.$refs.formbase.validate();
            if (!valid) return;
            this.loading = true;
            this.handleWebfs(
                process.env.VUE_APP_APIURL_FBB + "/api/v2/product/itemPublish",
                this.formData,
                {
                    executor: "request",
                    download: true,
                    method: "post",
                    headers: { "Content-Type": "application/json" },
                }
            );
            this.loading = false;
        },
        // async getSkuInfo(val) {
        //     if (!val) return;
        //     HttpGetSku({
        //         skuAlias: val,
        //     }).then(
        //         (res) => {
        //             console.log(res);
        //             const { sku, description } = res.data;
        //             this.formData = { ...this.formData, sku, description };
        //         },
        //         (err) => {
        //             this.$VMessage.error(err.message);
        //         }
        //     );
        // },
    },
};
</script>
